import React from 'react';
import Launch_error_messagesDF from '../components/SimulatorsComponents/DefualtSimulators/Launch_error_messagesDF';

//= ========================================================================
const Sim_T03_Launch_error_messages = ({
  globJSON,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <Launch_error_messagesDF
    globJSON={globJSON}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_T03_Launch_error_messages;
